import Clickable from '@carvana/merch-components/Clickable';
import { Text } from '@/vdp/styles';
import { appAssetsCdnUrl } from '~/constants/environment';
import { useTrackEvent } from '~/context/common/AnalyticsProvider';
import optimizeImage from '~/utilities/optimizeImage';
import StockImageBadge from './StockImageBadge';
import {
  Details,
  ImageryCard,
  ImageryCardContent,
  ImageryWrapper,
  StyledImage
} from './WhyBuyWithImageryCard.styles';

type OwnProps = {
  bulletPoint: {
    content?: string | null;
    title?: string | null;
  };
};

export default function WhyBuyWithImageryCard({ bulletPoint }: OwnProps) {
  const trackEvent = useTrackEvent();

  // TODO: replace with stock image data from the API (REO-9544)
  const isStockImage = true;

  // TODO: replace with real image data from the API (REO-9544)
  const optimizedMobileImageUrl = optimizeImage(
    `${appAssetsCdnUrl}/images/shaqvana/shaqvana-hero-bg-mobile.jpg`,
    { format: 'auto', height: 135, optimize: 'high', quality: 90 }
  );

  const handleClick = () => {
    // TODO: open new modal here (REO-9550)
    trackEvent('Why Buy Feature', {
      description: 'why buy feature',
      item: bulletPoint.title
    });
  };

  return (
    <Clickable
      data-adobe-id={null}
      data-analytics-id={null}
      data-testid="why-buy-imagery-card"
      element={ImageryCard}
      onClick={handleClick}
    >
      <ImageryWrapper>
        {/* TODO: replace placeholder with the feature image (REO-9544) */}
        <StyledImage
          className=""
          data-testid="why-buy-imagery-image"
          src={optimizedMobileImageUrl}
          alt="placeholder image"
          loading="lazy"
          draggable={false}
        />
        {isStockImage && <StockImageBadge />}
      </ImageryWrapper>
      <ImageryCardContent>
        <div className="line-clamp-4">
          <h3 className="mb-lg text-text-strong t-heading-sm">
            {bulletPoint.title}
          </h3>
          <Text>{bulletPoint.content}</Text>
        </div>
        <Details data-testid="why-buy-details">Details</Details>
      </ImageryCardContent>
    </Clickable>
  );
}
